export const handleHeight = (size: "sm" | "md" | "lg") => {
  switch (size) {
    case "sm":
      return "2rem";
    case "md":
      return "2.5rem";
    case "lg":
      return "3rem";
  }
};
export const handleFontSize = (size: "sm" | "md" | "lg") => {
  switch (size) {
    case "sm":
      return "0.75rem";
    case "md":
      return "0.875rem";
    case "lg":
      return "1rem";
  }
};
